import layeredSoilAttribute from './layeredSoilAttribute';

const pH = (allLayers: boolean) =>
  layeredSoilAttribute({
    allLayers,
    key: 'pH, 1:1 Water',
    ratingCol: {
      displayString: 'pH',
      accessor: 'mapUnitRatingString',
    },
    ruleId: '11',
  });

export const PH_ALL_LAYERS = pH(true);
export const PH_SURFACE_LAYER = pH(false);
